import { Input, Select } from "antd";
import React, { useContext } from "react";
import { TimeTrackingUserDataContext } from "../../../../TimeTrackingUserDataProvider";
import { EditSessionModalContext } from "./types";

const Dot: React.FC<{ color: string }> = ({ color }) => (
  <span
    style={{
      display: "inline-block",
      width: 10,
      height: 10,
      borderRadius: "50%",
      backgroundColor: color,
      flexShrink: 0,
    }}
  />
);

const CalendarTaskInput = () => {
  const { formData, setFormData } = useContext(EditSessionModalContext);
  const { projects } = useContext(TimeTrackingUserDataContext);

  const selectedProject = projects.find(
    (p) => p.projectId === formData.projectId,
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 4px",
        border: "1px solid #e8e8e8",
        borderRadius: 6,
        marginBottom: 12,
      }}
    >
      {/* Description */}
      <Input
        style={{
          flex: 1,
          border: "none",
          boxShadow: "none",
          fontSize: 15,
          fontWeight: 500,
        }}
        placeholder="What were you working on?"
        value={formData.description}
        onChange={(e) =>
          setFormData((prev) => ({ ...prev, description: e.target.value }))
        }
        maxLength={3000}
      />

      {/* Project select */}
      <div
        style={{
          borderLeft: "1px solid #e8e8e8",
          paddingLeft: 8,
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <Select
          bordered={false}
          style={{ minWidth: 160 }}
          value={formData.projectId || undefined}
          placeholder={
            <span style={{ color: "#aaa", fontSize: 15 }}>+ Project</span>
          }
          onChange={(value) =>
            setFormData((prev) => ({ ...prev, projectId: value }))
          }
          dropdownMatchSelectWidth={false}
          optionLabelProp="label"
          suffixIcon={
            selectedProject ? <Dot color={selectedProject.color} /> : undefined
          }
        >
          {projects.map((p) => (
            <Select.Option
              key={p.projectId}
              value={p.projectId}
              label={
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <Dot color={p.color} />
                  <span
                    style={{ color: p.color, fontWeight: 600, fontSize: 15 }}
                  >
                    {p.projectName}
                  </span>
                </span>
              }
            >
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Dot color={p.color} />
                <span style={{ color: p.color, fontWeight: 600 }}>
                  {p.projectName}
                </span>
              </span>
            </Select.Option>
          ))}
        </Select>
      </div>
    </div>
  );
};
export default CalendarTaskInput;
